var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "LR Number",
      prop: "lrNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "lrNumber",
      required: "",
      placeholder: "LR Number"
    },
    model: {
      value: _vm.formData.lrNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "lrNumber", $$v);
      },
      expression: "formData.lrNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "LR Date",
      prop: "lrDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Select Date",
      format: "dd-MM-yyyy"
    },
    model: {
      value: _vm.formData.lrDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "lrDate", $$v);
      },
      expression: "formData.lrDate"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };